import { fazendaIntegracaoService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const fazendaIntegracaoAction = {
    getFazendaIntegracaoByIdFazenda,
    getFazendaIntegracaoById,
    onChangeProps,
    editFazendaIntegracaoInfo,
    createFazendaIntegracao,
    deleteFazendaIntegracaoById,
    clear,
    clearCodigoIntegracao
};
function getFazendaIntegracaoByIdFazenda(idFazenda, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasIntegracoes/fazenda/' + idFazenda;
        fazendaIntegracaoService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeFazendaIntegracaosList(response.data));
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function getFazendaIntegracaoById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasIntegracoes/' + id;
        fazendaIntegracaoService.get(apiEndpoint)
            .then((response) => {
                dispatch(editFazendaIntegracaosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function createFazendaIntegracao(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasIntegracoes/';
        fazendaIntegracaoService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clearCodigoIntegracao());
                    alerts.success(ret.message);
                    dispatch(getFazendaIntegracaoByIdFazenda(payload.id_fazenda))
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function editFazendaIntegracaoInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasIntegracoes/' + id;
        fazendaIntegracaoService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    dispatch(clearCodigoIntegracao());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message);
                    dispatch(getFazendaIntegracaoByIdFazenda(payload.id_fazenda))
                } else {
                    alerts.warning(response.data.Message);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function deleteFazendaIntegracaoById(id, id_fazenda, showWaiting) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir a integração?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'fazendasIntegracoes/delete/' + id
                    fazendaIntegracaoService.put(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(updatedUserInfo());
                                dispatch(clear());
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                alerts.success(ret.message);
                                dispatch(getFazendaIntegracaoByIdFazenda(id_fazenda))
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });
    };
}
export function changeFazendaIntegracaosList(fazendaIntegracao) {
    return {
        type: "FETECHED_ALL_FAZENDA_INTEGRACAO",
        fazendaIntegracao: fazendaIntegracao
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editFazendaIntegracaosDetails(fazenda_integracao) {

    return {
        type: "FAZENDA_INTEGRACAO_DETAIL",
        id: fazenda_integracao.id,
        data_cadastro: fazenda_integracao.data_cadastro,
        usuario_cadastro: fazenda_integracao.usuario_cadastro,
        data_exclusao: fazenda_integracao.data_exclusao,
        usuario_exclusao: fazenda_integracao.usuario_exclusao,
        id_fazenda: fazenda_integracao.id_fazenda,
        codigo_integracao: fazenda_integracao.codigo_integracao,
        tipo: fazenda_integracao.tipo
    }
}
export function updatedUserInfo() {
    return {
        type: "FAZENDA_INTEGRACAO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "FAZENDA_INTEGRACAO_CREATED_SUCCESSFULLY"
    }
}
export function deleteFazendaIntegracaosDetails() {
    return {
        type: "DELETED_FAZENDA_INTEGRACAO_DETAILS"
    }
}
export function clear() {
    return {
        type: "FAZENDA_INTEGRACAO_CLEAR"
    };
}

export function clearCodigoIntegracao() {
    return {
        type: "FAZENDA_INTEGRACAO_CODIGO_CLEAR"
    };
}